import { InteractionStatus, RedirectRequest } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { CoherenceTheme } from "@coherence-design-system/styles";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Stack, ThemeProvider, loadTheme } from "@fluentui/react";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { scopes } from "./common/msal";
import CafeSync from "./components/CafeSync";
import DialogBox from "./components/DialogBox";
import HeaderComponent from "./components/Header";
import ImageManagement from "./components/ImageManagement";
import Loader from "./components/Loader/Loader";
import MenuManagement from "./components/MenuManagement";
import NavBar from "./components/NavBar";
import styles from "./styles/app.module.css";

initializeIcons();
loadTheme(CoherenceTheme);

const App = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    const redirectRequest: RedirectRequest = {
      scopes: [scopes.diningApi],
    };
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect(redirectRequest);
    }
  }, [isAuthenticated, inProgress, instance]);

  if (!isAuthenticated) {
    return <Loader loaderText="Loading..." />;
  } else {
    return (
      <ThemeProvider theme={CoherenceTheme} applyTo={"body"} className={styles.rootStyle} id={"ThemeProvider"}>
        <BrowserRouter data-testid={"RouterLevel"}>
          <Stack verticalFill={true}>
            <Stack.Item shrink={false}>
              <HeaderComponent />
            </Stack.Item>
            <main id="skipToMainContent" tabIndex={-1} className={styles.rootStyle}>
              <Stack horizontal={true} verticalFill={true}>
                <Stack.Item className={"navBar"}>
                  <NavBar />
                </Stack.Item>
                <Stack.Item grow={true}>
                  <DialogBox />
                  <Switch>
                    <Route path="/menus">
                      <MenuManagement />
                    </Route>
                    <Route path="/images">
                      <ImageManagement />
                    </Route>
                    <Route path="/cafeSync">
                      <CafeSync />
                    </Route>
                    <Route exact path="/">
                      <MenuManagement />
                    </Route>
                  </Switch>
                </Stack.Item>
              </Stack>
            </main>
          </Stack>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
};

export default App;
